export default __webpack_public_path__ + "assets/images/logo_2.f52939.png";